import { useEffect, useState } from "react";
import UserService from "../services/UserService";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Matchup, UserPicksResponse, Pick } from "models/Models";
import { Identity } from "models/LoginInfo";
import { Badge, Box, styled, Tab, Tabs } from "@mui/material";
import "./AllPicks.scss";
import { DataGrid, GridRenderCellParams } from "@mui/x-data-grid";
import { teamMap } from "services/TeamMap";
import { Style } from "@mui/icons-material";
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 5,
    top: 13,
    backgroundColor: `${theme.palette.background.paper}`,
    color: theme.palette.primary.main,
  },
}));
const StyledHeaderBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 5,
    top: 8,
    backgroundColor: "transparent",
    color: theme.palette.primary.main,
  },
}));

export default function AllPicks() {
  const [user, setUser] = useState<Identity>();
  const [series, setSeries] = useState<Matchup[]>();
  const [picks, setPicks] = useState<any[]>([]);
  const [round, setRound] = useState<number>(1);
  const [columns, setColumns] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const navigate = useNavigate();

  useEffect(() => {
    setUser(UserService.getUserInfo());
    axios.get<UserPicksResponse>(`${process.env.REACT_APP_API_URL}/pick/public`).then((r) => {
      setSeries(r.data.series);
      const result = r.data.users.map((user) => {
        const picks = r.data.picks.filter((c) => c.userId === user.userId);
        const userPicks = r.data.series.map((s) => {
          const match = picks.find((c) => c.seriesId === s.id);
          if (match) {
            if (s.homeTeamId === match.teamId) s.homeTeamPicks = (s.homeTeamPicks || 0) + 1;
            if (s.awayTeamId === match.teamId) s.awayTeamPicks = (s.awayTeamPicks || 0) + 1;
            return {
              round: s.round,
              seriesId: s.id,
              games: match.games,
              name: s.homeTeamId === match.teamId ? s.homeTeamName : s.awayTeamName,
              shortName: s.homeTeamId === match.teamId ? s.homeTeamShortName : s.awayTeamShortName,
            };
          } else {
            return { round: s.round, seriesId: s.id, name: "", shortName: "", games: 0 };
          }
        });
        const row = { user: user, name: user.teamName, id: user.userId } as any;
        userPicks.forEach((p) => {
          row[`${p.round}-${p.seriesId}`] = p.name;
          row[`${p.round}-${p.seriesId}-short`] = p.shortName;
          row[`${p.round}-${p.seriesId}-games`] = p.games;
        });
        return row;
      });
      setPicks(result);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    if (!series || !picks || !round) return;

    const columns = series
      .filter((c) => c.round === round)
      .map((c) => ({
        field: `${c.round}-${c.id}`,
        headerClassName: "highlighted-cell",
        align: "center",
        headerAlign: "center",
        renderCell: (params: GridRenderCellParams) => (
          <StyledBadge
            badgeContent={params.row[`${c.round}-${c.id}-games`]}
            color="primary"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <svg className="team-logo">
              <use xlinkHref={"/teams-dark.svg#team-" + teamMap[params.row[`${c.round}-${c.id}-short`]] + "-dark"}></use>
            </svg>
          </StyledBadge>
        ),
        renderHeader: () => (
          <div style={{ lineHeight: "1.5em", display: "flex", flexDirection: "row" }}>
            {/* {c.awayTeamName} */}
            <StyledHeaderBadge badgeContent={c.awayTeamWins || "0"} color="primary" anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
              <div className="team-logo-container">
                <svg className="team-logo">
                  <use xlinkHref={"/teams-dark.svg#team-" + teamMap[c.awayTeamShortName] + "-dark"}></use>
                </svg>
                <div className="total-picks" title="Number of teams who picked this team as the winner">
                  ({c.awayTeamPicks || 0})
                </div>
              </div>
            </StyledHeaderBadge>
            {/* <br /> {c.homeTeamName} */}
            <StyledHeaderBadge badgeContent={c.homeTeamWins || "0"} color="primary" anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
              <div className="team-logo-container">
                <svg className="team-logo">
                  <use xlinkHref={"/teams-dark.svg#team-" + teamMap[c.homeTeamShortName] + "-dark"}></use>
                </svg>
                <div className="total-picks" title="Number of teams who picked this team as the winner">
                  ({c.homeTeamPicks || 0})
                </div>
              </div>
            </StyledHeaderBadge>
          </div>
        ),
        width: 120,
        editable: false,
      }));
    columns.splice(0, 0, {
      field: "name",
      headerClassName: "highlighted-cell",
      cellClassName: "highlighted-cell",
      headerName: "",
      width: 150,
      editable: false,
    } as any);
    setColumns(columns);
  }, [round, series]);

  const handleRoundChange = (_: React.SyntheticEvent, value: number) => {
    setRound(value);
  };

  return (
    <div className="all-picks">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={round} onChange={handleRoundChange} aria-label="basic tabs example">
          <Tab label="Round 1" value={1} />
          <Tab label="Round 2" value={2} />
          <Tab label="Conference Finals" value={3} />
          <Tab label="Stanley Cup" value={4} />2
        </Tabs>
      </Box>
      <div className="data-grid-container">
        <DataGrid hideFooter={true} rows={picks} columns={columns} initialState={{}} loading={loading} />
      </div>
    </div>
  );
}
